/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetEarliestAndLatestTransactionDatesQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetEarliestAndLatestTransactionDatesQueryGQLType = (
  { __typename?: 'Query' }
  & { dates?: Types.Maybe<(
    { __typename?: 'TransactionDateRange' }
    & Pick<Types.TransactionDateRangeGQLType, 'earliestDate' | 'latestDate'>
  )> }
);

export type GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetDatesForCurrentLiabilityTransactionsQueryGQLType = (
  { __typename?: 'Query' }
  & { dates?: Types.Maybe<(
    { __typename?: 'TransactionDateRange' }
    & Pick<Types.TransactionDateRangeGQLType, 'earliestDate' | 'latestDate'>
  )> }
);

export type GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType = Types.Exact<{
  creditFacilityIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  loanIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
  accountTypes?: Types.Maybe<Array<Types.TAccountTypeGQLType> | Types.TAccountTypeGQLType>;
  startDate: Types.Scalars['FullDateStr'];
  endDate: Types.Scalars['FullDateStr'];
}>;


export type GetResolvedDetailedEntriesForFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { entries: Array<(
    { __typename?: 'ResolvedDetailedEntryItem' }
    & Pick<Types.ResolvedDetailedEntryItemGQLType, 'postingDate' | 'transactionType' | 'transactionCreatedAt' | 'comment' | 'amount' | 'tAccount' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'organizationId' | 'organizationSlug' | 'organizationName' | 'loanId' | 'loanName' | 'externalLoanId' | 'invoiceId'>
  )> }
);

export type GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType = Types.Exact<{
  creditFacilityIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  loanIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
  accountTypes?: Types.Maybe<Array<Types.TAccountTypeGQLType> | Types.TAccountTypeGQLType>;
  startDate: Types.Scalars['FullDateStr'];
  endDate: Types.Scalars['FullDateStr'];
}>;


export type GetDailyResolvedAggregateLineItemEntriesQueryGQLType = (
  { __typename?: 'Query' }
  & { entries: Array<(
    { __typename?: 'ResolvedAggregateLineItemEntry' }
    & Pick<Types.ResolvedAggregateLineItemEntryGQLType, 'postingDate' | 'tAccount' | 'creditFacilityId' | 'organizationId' | 'aggregateAmount' | 'loanId' | 'loanName' | 'externalLoanId' | 'invoiceId' | 'creditFacilitySlug' | 'creditFacilityName' | 'organizationSlug' | 'organizationName'>
  )> }
);

export type GetDailyAccountActivityQueryVariablesGQLType = Types.Exact<{
  creditFacilityIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  loanIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
  accountTypes?: Types.Maybe<Array<Types.TAccountTypeGQLType> | Types.TAccountTypeGQLType>;
  startDate: Types.Scalars['FullDateStr'];
  endDate: Types.Scalars['FullDateStr'];
}>;


export type GetDailyAccountActivityQueryGQLType = (
  { __typename?: 'Query' }
  & { activity?: Types.Maybe<(
    { __typename?: 'DailyAccountActivityResponse' }
    & { accountData: Array<(
      { __typename?: 'DailyAccountActivity' }
      & Pick<Types.DailyAccountActivityGQLType, 'postingDate' | 'tAccount' | 'aggregateAmount'>
    )>, metadata?: Types.Maybe<(
      { __typename?: 'AccountActivityMetadata' }
      & Pick<Types.AccountActivityMetadataGQLType, 'minDate' | 'maxDate' | 'accountTypes' | 'totalCurrentLiabilities'>
      & { accountTotals: Array<(
        { __typename?: 'TAccountTotalAmounts' }
        & Pick<Types.TAccountTotalAmountsGQLType, 'tAccount' | 'totalAmount'>
      )> }
    )> }
  )> }
);

export type GetCreditFacilityMetricsQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  postingDate: Types.Scalars['FullDateStr'];
}>;


export type GetCreditFacilityMetricsQueryGQLType = (
  { __typename?: 'Query' }
  & { metrics?: Types.Maybe<(
    { __typename?: 'CreditFacilityMetricsResponse' }
    & Pick<Types.CreditFacilityMetricsResponseGQLType, 'commitmentAmount' | 'externalFacilityId' | 'outstandingPrincipalBalance' | 'utilization' | 'totalAccruedInterest' | 'totalAccruedServiceFees'>
    & { borrower: (
      { __typename?: 'BaseOrganization' }
      & Pick<Types.BaseOrganizationGQLType, 'id' | 'name'>
    ) }
  )> }
);


export const GetEarliestAndLatestTransactionDatesDocumentGQLType = gql`
    query GetEarliestAndLatestTransactionDates($creditFacilityId: UUID!) {
  dates: getEarliestAndLatestTransactionDates(creditFacilityId: $creditFacilityId) {
    earliestDate
    latestDate
  }
}
    `;

/**
 * __useGetEarliestAndLatestTransactionDatesQuery__
 *
 * To run a query within a React component, call `useGetEarliestAndLatestTransactionDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestAndLatestTransactionDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestAndLatestTransactionDatesQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetEarliestAndLatestTransactionDatesQuery(baseOptions: Apollo.QueryHookOptions<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>(GetEarliestAndLatestTransactionDatesDocumentGQLType, options);
      }
export function useGetEarliestAndLatestTransactionDatesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>(GetEarliestAndLatestTransactionDatesDocumentGQLType, options);
        }
export type GetEarliestAndLatestTransactionDatesQueryHookResult = ReturnType<typeof useGetEarliestAndLatestTransactionDatesQuery>;
export type GetEarliestAndLatestTransactionDatesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEarliestAndLatestTransactionDatesLazyQueryGQLType>;
export type GetEarliestAndLatestTransactionDatesQueryResultGQLType = Apollo.QueryResult<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>;
export const GetDatesForCurrentLiabilityTransactionsDocumentGQLType = gql`
    query GetDatesForCurrentLiabilityTransactions($creditFacilityId: UUID!) {
  dates: getDatesForCurrentLiabilityTransactions(
    creditFacilityId: $creditFacilityId
  ) {
    earliestDate
    latestDate
  }
}
    `;

/**
 * __useGetDatesForCurrentLiabilityTransactionsQuery__
 *
 * To run a query within a React component, call `useGetDatesForCurrentLiabilityTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatesForCurrentLiabilityTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatesForCurrentLiabilityTransactionsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetDatesForCurrentLiabilityTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>(GetDatesForCurrentLiabilityTransactionsDocumentGQLType, options);
      }
export function useGetDatesForCurrentLiabilityTransactionsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>(GetDatesForCurrentLiabilityTransactionsDocumentGQLType, options);
        }
export type GetDatesForCurrentLiabilityTransactionsQueryHookResult = ReturnType<typeof useGetDatesForCurrentLiabilityTransactionsQuery>;
export type GetDatesForCurrentLiabilityTransactionsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDatesForCurrentLiabilityTransactionsLazyQueryGQLType>;
export type GetDatesForCurrentLiabilityTransactionsQueryResultGQLType = Apollo.QueryResult<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>;
export const GetResolvedDetailedEntriesForFacilitiesDocumentGQLType = gql`
    query getResolvedDetailedEntriesForFacilities($creditFacilityIds: [UUID!]!, $loanIds: [UUID!], $accountTypes: [TAccountType!], $startDate: FullDateStr!, $endDate: FullDateStr!) {
  entries: getResolvedDetailedEntriesForFacilities(
    creditFacilityIds: $creditFacilityIds
    loanIds: $loanIds
    accountTypes: $accountTypes
    startDate: $startDate
    endDate: $endDate
  ) {
    postingDate
    transactionType
    transactionCreatedAt
    comment
    amount
    tAccount
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    organizationId
    organizationSlug
    organizationName
    loanId
    loanName
    externalLoanId
    invoiceId
  }
}
    `;

/**
 * __useGetResolvedDetailedEntriesForFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetResolvedDetailedEntriesForFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedDetailedEntriesForFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedDetailedEntriesForFacilitiesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      loanIds: // value for 'loanIds'
 *      accountTypes: // value for 'accountTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetResolvedDetailedEntriesForFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>(GetResolvedDetailedEntriesForFacilitiesDocumentGQLType, options);
      }
export function useGetResolvedDetailedEntriesForFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>(GetResolvedDetailedEntriesForFacilitiesDocumentGQLType, options);
        }
export type GetResolvedDetailedEntriesForFacilitiesQueryHookResult = ReturnType<typeof useGetResolvedDetailedEntriesForFacilitiesQuery>;
export type GetResolvedDetailedEntriesForFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedDetailedEntriesForFacilitiesLazyQueryGQLType>;
export type GetResolvedDetailedEntriesForFacilitiesQueryResultGQLType = Apollo.QueryResult<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>;
export const GetDailyResolvedAggregateLineItemEntriesDocumentGQLType = gql`
    query GetDailyResolvedAggregateLineItemEntries($creditFacilityIds: [UUID!]!, $loanIds: [UUID!], $accountTypes: [TAccountType!], $startDate: FullDateStr!, $endDate: FullDateStr!) {
  entries: getDailyResolvedAggregateLineItemEntries(
    creditFacilityIds: $creditFacilityIds
    loanIds: $loanIds
    accountTypes: $accountTypes
    startDate: $startDate
    endDate: $endDate
  ) {
    postingDate
    tAccount
    creditFacilityId
    organizationId
    aggregateAmount
    loanId
    loanName
    externalLoanId
    invoiceId
    creditFacilitySlug
    creditFacilityName
    organizationSlug
    organizationName
  }
}
    `;

/**
 * __useGetDailyResolvedAggregateLineItemEntriesQuery__
 *
 * To run a query within a React component, call `useGetDailyResolvedAggregateLineItemEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyResolvedAggregateLineItemEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyResolvedAggregateLineItemEntriesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      loanIds: // value for 'loanIds'
 *      accountTypes: // value for 'accountTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDailyResolvedAggregateLineItemEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>(GetDailyResolvedAggregateLineItemEntriesDocumentGQLType, options);
      }
export function useGetDailyResolvedAggregateLineItemEntriesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>(GetDailyResolvedAggregateLineItemEntriesDocumentGQLType, options);
        }
export type GetDailyResolvedAggregateLineItemEntriesQueryHookResult = ReturnType<typeof useGetDailyResolvedAggregateLineItemEntriesQuery>;
export type GetDailyResolvedAggregateLineItemEntriesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyResolvedAggregateLineItemEntriesLazyQueryGQLType>;
export type GetDailyResolvedAggregateLineItemEntriesQueryResultGQLType = Apollo.QueryResult<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>;
export const GetDailyAccountActivityDocumentGQLType = gql`
    query GetDailyAccountActivity($creditFacilityIds: [UUID!]!, $loanIds: [UUID!], $accountTypes: [TAccountType!], $startDate: FullDateStr!, $endDate: FullDateStr!) {
  activity: getDailyAccountActivity(
    creditFacilityIds: $creditFacilityIds
    loanIds: $loanIds
    accountTypes: $accountTypes
    startDate: $startDate
    endDate: $endDate
  ) {
    accountData {
      postingDate
      tAccount
      aggregateAmount
    }
    metadata {
      minDate
      maxDate
      accountTypes
      accountTotals {
        tAccount
        totalAmount
      }
      totalCurrentLiabilities
    }
  }
}
    `;

/**
 * __useGetDailyAccountActivityQuery__
 *
 * To run a query within a React component, call `useGetDailyAccountActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyAccountActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyAccountActivityQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      loanIds: // value for 'loanIds'
 *      accountTypes: // value for 'accountTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDailyAccountActivityQuery(baseOptions: Apollo.QueryHookOptions<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>(GetDailyAccountActivityDocumentGQLType, options);
      }
export function useGetDailyAccountActivityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>(GetDailyAccountActivityDocumentGQLType, options);
        }
export type GetDailyAccountActivityQueryHookResult = ReturnType<typeof useGetDailyAccountActivityQuery>;
export type GetDailyAccountActivityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyAccountActivityLazyQueryGQLType>;
export type GetDailyAccountActivityQueryResultGQLType = Apollo.QueryResult<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>;
export const GetCreditFacilityMetricsDocumentGQLType = gql`
    query GetCreditFacilityMetrics($creditFacilityId: UUID!, $postingDate: FullDateStr!) {
  metrics: getCreditFacilityMetrics(
    creditFacilityId: $creditFacilityId
    postingDate: $postingDate
  ) {
    borrower {
      id
      name
    }
    commitmentAmount
    externalFacilityId
    outstandingPrincipalBalance
    utilization
    totalAccruedInterest
    totalAccruedServiceFees
  }
}
    `;

/**
 * __useGetCreditFacilityMetricsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityMetricsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      postingDate: // value for 'postingDate'
 *   },
 * });
 */
export function useGetCreditFacilityMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>(GetCreditFacilityMetricsDocumentGQLType, options);
      }
export function useGetCreditFacilityMetricsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>(GetCreditFacilityMetricsDocumentGQLType, options);
        }
export type GetCreditFacilityMetricsQueryHookResult = ReturnType<typeof useGetCreditFacilityMetricsQuery>;
export type GetCreditFacilityMetricsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityMetricsLazyQueryGQLType>;
export type GetCreditFacilityMetricsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>;